/**
 * 查新任务创建数据
 */
export interface NoveltyCheckTaskData {
    /**
     * 任务 id
     */
    taskId: string;
    /**
     * 文本内容
     */
    text: string;
    /**
     * 附件 id 列表
     */
    attachmentIds?: string[];
    /**
     * 公开日期开始
     */
    pbdStart?: string;
    /**
     * 公开日期结束
     */
    pbdEnd?: string;
}

/**
 * 查新任务创建服务
 */
export interface NoveltyCheckTaskCreator {
    /**
     * 创建查新任务
     * @description 创建任务成功后，会更新检索结果报告模型 {@link RetrievalResultReportModel} 的 techEssential 和 userInput 字段
     * @param data 创建查新任务数据
     * @returns
     */
    createTask(data: NoveltyCheckTaskData): Promise<void>;
}

export const NoveltyCheckTaskCreator = Symbol.for('NoveltyCheckTaskCreator');
